import { render, staticRenderFns } from "./ocr-type.vue?vue&type=template&id=f872bef4"
import script from "./ocr-type.vue?vue&type=script&setup=true&lang=js"
export * from "./ocr-type.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ocr-type.vue?vue&type=style&index=0&id=f872bef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports